/**
 * Règles métier du dialogue « Nouveau paiement », extraites de
 * PaymentDialog pour être testables. Corps identiques au code d'origine.
 */

/** Seuls les paiements encaissés (completed) réduisent le reste à payer. */
export const completedTotal = (
  payments: Array<{ status?: string | null; amount?: number | null }>
): number =>
  payments
    .filter((r) => String(r?.status ?? "").toLowerCase() === "completed")
    .reduce((s, r) => s + (r.amount ?? 0), 0);

export type OverpaymentCheck = { ok: true } | { ok: false; overflow: string };

/**
 * Refuse un paiement qui porterait le total encaissé AU-DELÀ du prix de
 * l'abonnement (l'égalité stricte est autorisée : solder exactement passe).
 */
export const checkOverpayment = (
  totalPaid: number,
  amount: number,
  price: number | null | undefined
): OverpaymentCheck => {
  const wouldBeTotal = totalPaid + amount;
  if (wouldBeTotal > (price ?? 0)) {
    const overflow = (wouldBeTotal - (price ?? 0)).toFixed(2);
    return { ok: false, overflow };
  }
  return { ok: true };
};
